// frontend/src/content/dailyMirror.js
// V1: Local-only content. No backend required.

export const DAILY_MIRROR_CYCLE_LENGTH = 56;

/**
 * 56 affirmations (8-week loop).
 * Tone: grounded, non-cheesy, identity + boundaries + honesty + love.
 */
export const DAILY_AFFIRMATIONS = [
  "I am worthy of love that feels safe and honest.",
  "My needs matter, and I can name them clearly.",
  "I choose connection that aligns with my values.",
  "I can be kind to myself while I grow.",
  "I am allowed to take up space without apology.",
  "I honor my boundaries and respect others' boundaries.",
  "I communicate with clarity, courage, and care.",
  "I release the need to be perfect to be loved.",
  "I trust myself to make wise choices in love.",
  "I deserve relationships built on honesty and consent.",
  "I can ask for what I want without shame.",
  "I am learning to receive love without suspicion.",
  "My peace is worth protecting.",
  "I choose to be present instead of perform.",
  "I forgive myself for what I did not know then.",
  "I am safe to tell the truth.",
  "I can love deeply without abandoning myself.",
  "I am not behind; I am becoming.",
  "I belong in spaces that celebrate my whole self.",
  "I am allowed to change my mind as I learn.",
  "I deserve respect in words, actions, and patterns.",
  "I can handle difficult conversations with grace.",
  "I am learning to choose consistency over chemistry alone.",
  "I honor my body, my time, and my energy.",
  "I am proud of the ways I show up for myself.",
  "I am open to love that is steady and real.",
  "I can be soft and strong at the same time.",
  "I choose partners who match effort with effort.",
  "I am allowed to rest.",
  "I release relationships that require me to shrink.",
  "I trust my intuition and verify with facts.",
  "I can be honest without being harsh.",
  "I am learning to repair instead of run.",
  "I deserve to be chosen without confusion.",
  "I treat myself with the same respect I expect.",
  "I am worthy of gentle love and clear commitment.",
  "I can set boundaries and still be loving.",
  "I am free to be seen.",
  "I choose courage over avoidance.",
  "I can move through fear without letting it drive.",
  "I accept myself today, not someday.",
  "I release the need to prove my value.",
  "I am learning to trust what is consistent.",
  "I welcome love that feels mutual.",
  "I can hold my standards with compassion.",
  "I am allowed to want what I want.",
  "I speak my truth with calm confidence.",
  "I practice patience with myself and my process.",
  "I choose honesty, even when it is uncomfortable.",
  "I can be loved exactly as I am.",
  "I am not too much; I am real.",
  "I deserve love that includes accountability.",
  "I am learning to trust love that feels peaceful.",
  "I honor my growth and my healing.",
  "Today, I choose myself and the love I deserve."
];

/**
 * Mirror prompts live in a separate interface.
 * They're questions/cues to face reality + choose self-compassion anyway.
 */
export const MIRROR_PROMPTS = [
  "Take one breath. What emotion is closest to the surface right now?",
  "What would it look like to treat yourself gently today?",
  "Where are you being harder on yourself than you need to be?",
  "What do you need to hear from yourself today?",
  "Name one thing you did well recently — even if it was small.",
  "What are you avoiding because it feels uncomfortable?",
  "What truth are you ready to admit to yourself?",
  "Where are you saying yes when your body says no?",
  "What boundary would protect your peace this week?",
  "What part of you needs compassion, not correction?",
  "If your best friend felt what you feel, what would you tell them?",
  "What are you proud of yourself for surviving?",
  "What does self-respect look like in your actions today?",
  "Where do you need to slow down and be present?",
  "What fear is trying to drive today — and what would love choose instead?",
  "What do you want, without explaining it or justifying it?",
  "What do you need, without minimizing it?",
  "What pattern keeps showing up in your relationships?",
  "What is the lesson, without the shame?",
  "Where are you confusing intensity for compatibility?",
  "What does safety feel like in your body?",
  "What does healthy love require from you?",
  "What is one way you can show up for yourself in the next hour?",
  "What are you tolerating that you no longer want to tolerate?",
  "Where do you need to tell the truth more clearly?",
  "What are you grateful for about who you are becoming?",
  "What part of you feels unseen — and how can you see it first?",
  "What is one boundary you wish you had set sooner?",
  "What would it look like to forgive yourself for being human?",
  "What are you learning to accept about yourself?",
  "What does your inner child need from you right now?",
  "What does your future self want you to stop doing?",
  "What does your future self want you to start doing?",
  "Where are you abandoning yourself to keep someone close?",
  "What does love look like when it is mutual?",
  "What are you afraid people will see in you — and is it actually wrong?",
  "What is one thing you can release today?",
  "What is one thing you can reclaim today?",
  "What does honesty sound like, in a calm voice?",
  "Where do you need accountability — without self-hate?",
  "What does your nervous system need to feel calm?",
  "What is your heart asking for that your pride resists?",
  "What would it look like to choose peace over proving?",
  "Where are you seeking validation instead of alignment?",
  "What would make you respect yourself more tomorrow morning?",
  "What desire have you been pretending you don't have?",
  "What part of your life is asking for a clean reset?",
  "What conversation are you postponing — and why?",
  "What is one way you can be brave with love today?",
  "Where do you need to apologize to yourself?",
  "Where do you need to celebrate yourself?",
  "What standard are you ready to raise?",
  "What standard are you ready to stop compromising?",
  "What is one small promise you can keep to yourself today?",
  "What is one belief about yourself you are ready to upgrade?",
  "What would it look like to love yourself without conditions?",
  "What reality are you ready to face so you can finally be free?",
  "Look at yourself with kindness. What do you notice?"
];

export const DAILY_MIRROR_STORAGE_KEYS = {
  startDate: "ul_daily_mirror_start_date",
  completedDates: "ul_daily_mirror_completed_dates",
  lastPromptShownAt: "ul_mirror_prompts_last_shown_at"
};
